import { ReactNode } from 'react'
import { Drawer } from '@/components/ui'

interface ProfileDrawerProps {
  title: string
  open: boolean
  onClose: () => void
  width?: number
  children: ReactNode
  extra?: ReactNode
}

/**
 * Shared ProfileDrawer component for displaying profile/detail views
 * Used for viewing attendee profiles and other detail pages
 */
export default function ProfileDrawer({
  title,
  open,
  onClose,
  width,
  children,
  extra,
}: ProfileDrawerProps) {
  return (
    <Drawer
      title={title}
      open={open}
      onClose={onClose}
      width={width}
      showFooter={false}
      extra={extra}
    >
      {children}
    </Drawer>
  )
}
